import { useState } from 'react'
import { CheckIcon } from '@heroicons/react/24/outline'

export default function AgentSettingsForm({ agent, onSave }) {
  const [settings, setSettings] = useState(agent.settings || {})
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  const handleSave = async () => {
    setSaving(true)
    setSaved(false)
    try {
      await onSave(agent.slug, settings)
      setSaved(true)
      setTimeout(() => setSaved(false), 2000)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="space-y-4">
      {settings.confidence_threshold !== undefined && (
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1.5">
            Confidence Threshold: <span className="font-mono">{settings.confidence_threshold}</span>
          </label>
          <input
            type="range"
            min="0.1"
            max="1.0"
            step="0.05"
            value={settings.confidence_threshold}
            onChange={(e) => setSettings({ ...settings, confidence_threshold: parseFloat(e.target.value) })}
            className="w-full accent-brand-600"
          />
          <div className="flex justify-between text-xs text-slate-400 mt-1">
            <span>Loose (0.1)</span>
            <span>Strict (1.0)</span>
          </div>
        </div>
      )}

      {agent.slug === 'lead-capture' && settings.trigger !== undefined && (
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1.5">Trigger Mode</label>
          <select
            value={settings.trigger}
            onChange={(e) => setSettings({ ...settings, trigger: e.target.value })}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500"
          >
            <option value="auto">Automatic</option>
            <option value="manual">Manual</option>
            <option value="intent">Intent-Based</option>
          </select>
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={saving}
        className="flex items-center gap-1.5 px-3 py-1.5 text-xs bg-brand-600 text-white rounded-lg hover:bg-brand-700 disabled:opacity-50 transition-colors"
      >
        {saving ? 'Saving...' : saved ? (
          <>
            <CheckIcon className="h-3 w-3" />
            Saved
          </>
        ) : 'Save Settings'}
      </button>
    </div>
  )
}
